// @ts-ignore
import { atom } from 'recoil';
export const snackbarPropsState = atom({
    key: 'Snackbarprovider/SnackbarPropsState',
    default: null
});
export const snackbarOpenState = atom({
    key: 'Snackbarprovider/SnackbarOpenState',
    default: false,
});
export const snackbarIdState = atom({
    key: 'Snackbarprovider/SnackbarIdState',
    default: '',
});
